import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import {loadDates, selectDateState} from "../../reducer/dateSlice";
import AdminService from "../../services/admin.service";
import FundList from "./FundList";
import {Accordion} from "react-bootstrap";
import Select from "react-select";
import ajaxloader from "../../images/ajax-loader.gif";

export default function FundScan(props) {

    const dispatch = useDispatch();

    const clientConfig = props.clientConfig;
    const dateOption = props.dateOption;

    const {dates, dateStatus} = useSelector(selectDateState);

    const [scanDateOption, setScanDateOption] = useState(dateOption); // Init with the pf date
    const [dateOptions, setDateOptions] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState('idle');
    const [summary, setSummary] = useState(null);
    const [saveMessages, setSaveMessages] = useState([]);

    const borderLeft = 'border-left';

    // Load some dates
    useEffect(() => {
        if (dateStatus === "idle") {
            dispatch(loadDates());
        }
    }, [dateStatus]);

    useEffect(() => {
        let optionsTmp = [];

        dates.forEach(date => {
            if (date >= dateOption.value) {
                const option = {value: date, label: date};
                optionsTmp.push(option);
            }
        });

        setDateOptions(optionsTmp);
    }, [dates]);

    const handleDateChange = (date, action) => {
        setScanDateOption(date);
    }

    function doFundScan() {
        if (loadingStatus !== 'loading') {
            setSummary(null);
            setLoadingStatus('loading');

            AdminService.fundScan({
                clientId: clientConfig.clientWrapper.id,
                dateStr: dateOption.value, // portfolio date
                scanDateStr: scanDateOption ? scanDateOption.value : null // scan date, if null use the pf date
            })
                .then(response => {
                        const respData = response.data;
                        if (respData) {
                            setLoadingStatus('success');
                            setSummary(respData.data);
                        } else {
                            setLoadingStatus('error');
                            setSaveMessages(null);
                        }
                    },
                    error => {
                        setLoadingStatus('error');
                    });
        }
    }

    let result;

    switch (loadingStatus) {
        case 'loading':
            result = <></>
            break;
        case 'error':
            result = <div className="form-group">
                <br/>
                <h5>Summary:</h5>
                <div className={"alert import_log"}>
                    {saveMessages && saveMessages.length > 0 && saveMessages.map(message => {
                        return <><span
                            className={"import_log_" + message.key}>{message.value}</span><br/></>
                    })}
                </div>
            </div>;
            break;
        case 'success':

            const isinWidth = '140px';
            const padding = '0.55em 0.5em';

            result = <>
                {summary && <>
                    <div className={'border-top background-light'}>
                        <div style={{display: "flex", flexWrap: "nowrap"}}>
                            <div className={"setup-th"} style={{flexBasis: isinWidth}}>
                                Summary
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>
                                Positions
                            </div>
                            <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>
                                Amount
                            </div>
                        </div>
                    </div>
                    <div className={'setup-row'}>
                        <div className={"setup-th"} style={{flexBasis: isinWidth}}>
                            Portfolio
                        </div>
                        <div className={"setup-th right " + borderLeft} style={{flexBasis: isinWidth}}>
                            {summary.nbPos}
                        </div>
                        <div className={"setup-th right " + borderLeft} style={{flexBasis: isinWidth}}>
                            {summary.totalAmountFmt}
                        </div>
                    </div>
                    <div className={'setup-row'}>
                        <div className={"setup-col"} style={{flexBasis: isinWidth, padding: padding}}>
                            Funds
                        </div>
                        <div className={"setup-col right " + borderLeft}
                             style={{flexBasis: isinWidth, padding: padding}}>
                            {summary.nbFunds}
                        </div>
                        <div className={"setup-col right " + borderLeft}
                             style={{flexBasis: isinWidth, padding: padding}}>
                            {summary.totalFundAmountFmt}
                        </div>
                    </div>
                    <div className={'setup-row'}>
                        <div className={"setup-col"} style={{flexBasis: isinWidth, padding: padding}}>
                            Funds (distinct, including sub-funds)
                        </div>
                        <div className={"setup-col right " + borderLeft}
                             style={{flexBasis: isinWidth, padding: padding}}>
                            {summary.nbDistinctFunds}
                        </div>
                        <div className={"setup-col right " + borderLeft}
                             style={{flexBasis: isinWidth, padding: padding}}>
                            {summary.totalFundAmountFmt}
                        </div>
                    </div>

                    {/*<div className={'border-top background-light'} style={{marginTop: "1rem"}}>*/}
                    {/*    <div style={{display: "flex", flexWrap: "nowrap"}}>*/}
                    {/*        <div className={"setup-th"} style={{flexBasis: isinWidth}}>*/}
                    {/*            Look-through*/}
                    {/*        </div>*/}
                    {/*        {summary.coverageBySourceType.map((item, index) => {*/}
                    {/*            return <div key={item.label} className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>*/}
                    {/*                {item.label}*/}
                    {/*            </div>*/}
                    {/*        })}*/}
                    {/*        <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>*/}
                    {/*            ->*/}
                    {/*        </div>*/}
                    {/*        <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>*/}
                    {/*            <LabelWithTooltip label={"Current"} text={LEGENDS["currentFundSourceFilter"]}/>*/}
                    {/*        </div>*/}
                    {/*        <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>*/}
                    {/*            <LabelWithTooltip label={"Default"} text={LEGENDS["defaultFundSourceFilter"]}/>*/}
                    {/*        </div>*/}
                    {/*        <div className={"setup-th " + borderLeft} style={{flexBasis: isinWidth}}>*/}
                    {/*            Delta*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<FundCompositionCoverage summary={summary}*/}
                    {/*                         prop={'nbAtDate'}*/}
                    {/*                         prop2={'coverageAtDateFmt'}*/}
                    {/*                         prop3={'deltaCovAtDateFmt'}*/}
                    {/*                         prop4={'statsAtDateBySource'}*/}
                    {/*                         label={summary.dateFmt}/>*/}
                    {/*<FundCompositionCoverage summary={summary}*/}
                    {/*                         prop={'nb3Months'}*/}
                    {/*                         prop2={'coverage3MonthsFmt'}*/}
                    {/*                         prop3={'deltaCov3MonthsFmt'}*/}
                    {/*                         prop4={'stats3MonthsBySource'}*/}
                    {/*                         label={'3 Months'}/>*/}
                    {/*<FundCompositionCoverage summary={summary}*/}
                    {/*                         prop={'nbOlder'}*/}
                    {/*                         prop2={'coverageOlderFmt'}*/}
                    {/*                         prop3={'deltaCovOlderFmt'}*/}
                    {/*                         prop4={'statsOlderBySource'}*/}
                    {/*                         label={'Older'}/>*/}
                    {/*<FundCompositionCoverage summary={summary}*/}
                    {/*                         prop={'nbTotal'}*/}
                    {/*                         prop2={'coverageTotalFmt'}*/}
                    {/*                         prop3={'deltaCovTotalFmt'}*/}
                    {/*                         prop4={'statsTotalBySource'}*/}
                    {/*                         label={'Total'}/>*/}

                    <FundList compositions={summary.compositions} clientConfig={clientConfig} date={dateOption.value}/>
                </>
                }
            </>;
            break;
    }

    return <>
        <div className={'detail-title'}>
            <p className={'canopia2 detail-title-font'}>Look-through</p>
        </div>
        <Accordion>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    Show / hide documentation
                </Accordion.Header>
                <Accordion.Body>
                    <p style={{marginTop: '20px'}}>
                        Show the available look-through for all identified funds part of the portfolio at the given
                        date.
                    </p>
                    <p><b>Fund identification</b></p>
                    <p>
                        In order to be considered as a fund, the fund must be identified accordingly. It can be achieved
                        using either of these two options:
                        <ul>
                            <li>The column <b>Asset Type</b> in the DBSpec file, which must be tagged in a way Canopia
                                knows
                                it is a fund, e.g.: <i>StandFunds, SriFunds, Funds, Fund, Fund - Equity, Fund - Fixed
                                    Income, ...</i>,
                                or from an old enum: <i>Equity fund, Fixed income fund, ...</i>
                            </li>
                            <li>The fund ISIN is already known in Canopia Fund DB. It may be a custom built ISIN
                                like <i>UBS_EQ_WD</i></li>
                        </ul>
                    </p>
                    <p><b>Glossary</b></p>
                    <p>Source: connexion channel through which the data transfer is made</p>
                    <p>Source type: group of sources
                        <ul>
                            <li>AM: sources using a direct connection to the asset manager of the fund</li>
                            <li>client: sources using a direct connection to the client invested in the fund</li>
                            <li>external: indirect sources using indirect data providers like Lipper</li>
                        </ul>
                    </p>
                    <p>Asset Manager: the AM name in case the source type used is AM</p>
                    <p>Current setup: list of source types defined for this specific client required to load the
                        different look-through, this is defined under <b>Global Params /
                            fundSourceFilterCsv</b></p>
                    <p><b>Data Model</b></p>
                    <p>An AM may have several sources (of type AM) and be:
                        <ul>
                            <li>open -> free access to all clients</li>
                            <li>protected by a NDA
                                <ul>
                                    <li>No restriction -> free access to all clients</li>
                                    <li>restricted to specific clients</li>
                                </ul>
                            </li>
                            <li>closed -> no access</li>
                        </ul>
                    </p>
                    <p><b>Look-through scan</b></p>
                    <p>
                        As soon as a fund has been identified the scan will use the ISIN to access the look-through.
                        <ul>
                            <li>For valid ISINs (https://www.isin.org/isin-format/), the scan will be
                                done over all available ISINs part of the same group (class A, B, Z, ...).
                            </li>
                            <li>For invalid ones, this step is skipped.</li>
                        </ul>
                        The scan depends on the <b>Global Params</b> to show both the Current setup and the AM one with
                        a corresponding status shown in the column <b>Spec. Hand.</b>.
                        <ul>
                            <li><b>skipMoneyMktFunds</b>: If true, money market funds (identified by its <b>Asset
                                Type</b>) look-throughs are ignored with status <b>Skipped MM</b></li>
                            <li><b>useFundSubstitutionTable</b>: If true, special handling may occur, listed below</li>
                            <li><b>useFundRemoval</b>: If true, ignored look-through with status <b>Discarded</b></li>
                            <li><b>useFundSubstitution</b>: If true, substituted look-through with status <b>Subst.
                                fund</b></li>
                            <li><b>useFundGlobalRating</b>: If true, ignored look-through with status <b>Global
                                rating</b></li>
                        </ul>
                        {/*The scan will show the number of available look-through among the <b>direct funds</b> for each source type and for both the current and default setups.*/}
                        {/*Sub-funds are not scanned for the time being.*/}
                    </p>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        <p style={{marginTop: '20px'}}>
            Show available look-through for all identified direct funds part of the portfolio at the given date.
        </p>
        <p>
            The scan is made live (no cache is used) so the more funds are scanned, the longer the process will take.
        </p>
        <p>
            You may choose to scan a specific date to get the latest state of the funds, based on the current portfolio.
        </p>
        <div className={'setup-form-row'}>
            <div className={'setup-form-label'}>
                <label>Scan date</label>
            </div>
            <Select options={dateOptions}
                    placeholder={'yyyy-MM-dd'}
                    name={'date-select'}
                    value={scanDateOption}
                    closeMenuOnSelect={true}
                    onChange={handleDateChange}/>
        </div>

        <button style={{margin: '1rem 0'}} className="btn btn-primary btn-block" disabled={loadingStatus === 'loading'}
                onClick={doFundScan}>
            {loadingStatus === 'loading' && (<span className="spinner-border spinner-border-sm"
                                                   style={{marginRight: '5px'}}/>)}
            <span>Scan</span>
        </button>
        {result}
    </>
}